import { render, staticRenderFns } from "./ApplicantInfo.vue?vue&type=template&id=96dce950"
import script from "./ApplicantInfo.vue?vue&type=script&lang=js"
export * from "./ApplicantInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports